import { actionTypes } from '../actions/residential'

const initial = {
	directors: [],
	news: [],
  imis: [],
  property_types: [],
  ubications: [],
  unit_state: [],
  is_new: false,
  is_professional_use: false
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.RECEIVE_DIRECTORS:
      return Object.assign({}, state, {
        directors: action.data
    })

    case actionTypes.RECEIVE_NEWS:
      return Object.assign({}, state, {
        news: action.data
    })

    case actionTypes.RECEIVE_IMIS:
      return Object.assign({}, state, {
        imis: action.data
    })

    case actionTypes.RECEIVE_RESIDENTIAL_TYPES:
      return Object.assign({}, state, {
        property_types: action.data
    })

    case actionTypes.RECEIVE_UBICATIONS:
      return Object.assign({}, state, {
        ubications: action.data
    })

    case actionTypes.RECEIVE_UNIT_STATE:
      return Object.assign({}, state, {
        unit_state: action.data
    })

    case actionTypes.SET_PROFESSIONAL_USE:
      return Object.assign({}, state, {
        is_professional_use: !state.is_professional_use
    })

    case actionTypes.SET_NEW:
      return Object.assign({}, state, {
        is_new: !state.is_new
    })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/residential.js